export const types = {
    SET_GET_LIST_LANGUAGE: '[LANGUAGE] SET GET LIST',
    SET_GET_LIST_DICTIONARY: '[DICTIONARY] SET GET LIST DICTIONARY'
}